"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  images: [],
  frames: [[50, 0, 320, 320, 0, 0, 0]],
  animations: {
    all: {
      speed: 1,
      frames: [0]
    }
  },
  framerate: 24
};